import User from "../../../apis/User";
import Roles from "../../../apis/Roles";
import router from "../../../router";

const state = {
    roles: [],
    roleError: ""
};

const getters = {
    getRoles: () => state.roles.map(el => (
        {
            id: el.id,
            guard_name: el.guard_name,
            name: el.name,
            permissions: el.permissions
        }
    ))
};

const actions = {
    getAllRoles({ commit }) {
        return new Promise((resolve, reject) => {
            Roles.index()
                .then((response) => {
                    resolve(response.data.data[0]);
                    commit("GET_ALL_ROLES", response.data.data[0])
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("GET_ALL_ROLES", []);
                        commit("DETECT_ROLE_ERROR", error.response);
                    }
                })
        });
    },
    getRole({ commit }, id) {
        return new Promise((resolve, reject) => {
            Roles.show(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("GET_ROLE", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_ROLE_ERROR", error.response);
                    }
                })
        })
    },
    createRole({ commit }, obj) {
        return new Promise((resolve, reject) => {
            Roles.store(obj)
                .then((response) => {
                    resolve(response.data.data);

                    commit("CREATE_ROLE", response.data.data);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_ROLE_ERROR", error.response);
                    }
                })
        })
    },
    updateRole({ commit }, { id, obj }) {
        return new Promise((resolve, reject) => {
            Roles.update(id, obj)
                .then((response) => {
                    resolve(response.data.data);
                    commit("UPDATE_ROLE", obj);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_ROLE_ERROR", error.response);
                    }
                })
        })
    },
    removeRole({ commit }, id) {
        return new Promise((resolve, reject) => {
            Roles.delete(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("REMOVE_ROLE", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_ROLE_ERROR", error.response);
                    }
                })
        })
    }
};

const mutations = {
    GET_ALL_ROLES(state, response) {
        state.roles = response;
    },
    GET_ROLE(state, id) {

    },
    CREATE_ROLE(state, obj) {
        state.roles.push(obj);
    },
    UPDATE_ROLE(state, obj) {
        let objIndexToUpdate = state.roles.findIndex(el => el.id === obj.id);
        state.roles[objIndexToUpdate] = obj;
    },
    REMOVE_ROLE(state, id) {
        let objIndexToDelete = state.roles.findIndex(el => el.id === id);

        state.roles.splice(objIndexToDelete, 1);
    },
    DETECT_ROLE_ERROR(state, error) {
        setTimeout(() => {
            state.roleError = "";
        }, 1000)

        if (error.status == 401 || error.status == 419) {
            User.logout().then(() => {
                localStorage.removeItem("auth");
                router.push({ name: "Login", path: router.currentRoute.path });
            })
        } else if (error.data.message !== undefined) {
            state.roleError = error.data.message;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}